import EventParticipationRateTable from 'widgets/EventParticipationRateTable/EventParticipationRateTable'

export default EventParticipationRateTable
